const blockquote = document.querySelectorAll('.blockquote-swiper');

if (blockquote.length !== 0) {
(async () => {
    const { default: Swiper } = await import('swiper/bundle');
    const blockquoteSwiper = new Swiper('.blockquote-swiper', {
        loop: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
    });
})();
}